import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ConfigurationService } from 'src/app/components/core/_infrastructure/classes/services/configuration.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { RequestService } from 'src/app/components/core/_infrastructure/types/common';
import { AsyncInfoService } from '../../../core/components/asyncInfo/asyncInfo.service';
import { AsyncInfoRequestViewModel, AsyncInfoResponseViewModel } from '../../../core/components/asyncInfo/asyncInfo.types';
import { ValidationBussinessErrorViewModel, ValidationInfoResponseViewModel } from '../../../core/_infrastructure/types/web.services';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { SolicitudViewModel } from '../datosbasicos/datosbasicos.types';
import { InspeccionSubmitPostRequest } from '../inspecciones/inspecciones.types';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcFormatoSolicitud,
    EnumIdsTcSubTipoSolicitud,
    EnumIdsTwTcTipoClonacion,
    EnumIdsTcTipoSolicitud,
} from '../types/enum';
import { EnvioService } from './envio.service';
import { NumerosAutorizacionViewModel } from './envio.types';

@Component({
    selector: 'app-envio',
    templateUrl: './envio.component.html',
})
export class EnvioComponent extends ComponentBase implements OnInit {
    solicitud: SolicitudViewModel;
    mostrarBotones = false;
    habilitarEnviar = false;
    habilitarEdicion = false;
    visibilidadNoPrevia = false;
    visibilidadReenvioTraces = false;
    showNRC = false;
    loadingEnvio = false;
    IdSolicitud: number;

    validacionCollection: string[];
    codigoSolicitud: string | null = null;
    codigoTraces: string | null = null;
    identificadorNoProcede: string | null = null;
    fechaSolicitud: string | null = null;
    tituloBoton = 'Enviar';
    esGrabador = false;
    esInspector = false;
    esSolicitante = false;
    esConsultas = false;
    esAeropuerto: boolean;
    IdTipoSolicitud: number;
    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;
    esPredua = false;
    showTracesWS = false;
    showSubmitWS = false;
    showAduanasWS = false;
    isCollapsedReenvioTraces = false;
    deshabilitarSubmit = true;

    visibilitySpinner = false;
    visibilitySpinnerV3 = false;
    visibilitySpinnerV3Reset = false;
    visibilitySpinnerTNT = false;
    visibilitySpinnerTNTReset = false;
    visibilitySubmitWS = false;

    erroresEnvioTraces: ValidationBussinessErrorViewModel[] | null;
    errorEnvioAduanas: ValidationBussinessErrorViewModel | null;

    visibilityErroresAduanas = false;
    visibilityErroresTraces = false;
    visibilityCheckEnvioValue: boolean | null = null; //flag para mostrar icono check verde, icono de atención o ninguno

    mensajeEmision = ''; //mensaje informativo que aparece junto al check verde/atención de envío
    laHeGrabadoYo = false;
    esClonada = false;
    esRevisionSolicitante = false;
    inspeccionSubmitPostRequest: InspeccionSubmitPostRequest;
    firmado = false;
    firmaSolicitante = '';
    firmaEmail = '';
    labelEmailOtlf = '';
    SolicitanteOrazonSocial = '';
    EmailOtlf = '';
    esCanariasCf = false;
    listNumAutorizacion: NumerosAutorizacionViewModel[] | null;

    constructor(
        private fb: FormBuilder,
        public datepipe: DatePipe,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private navMenuService: NavMenuService,
        protected authService: AuthService,
        private confirmationService: ConfirmationService,
        protected notificacionService: NotificationService,
        protected configurationService: ConfigurationService,
        protected asyncInfoService: AsyncInfoService,
        protected exceptionHandler: ExceptionManager,
        private solicitudService: SolicitudService,
        private envioService: EnvioService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitud = new SolicitudViewModel();
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];
        this.IdSolicitud = id;

        this.guardRefreshPage(id);

        this.esGrabador = this.isGrabador;
        this.esInspector = this.isInspector;
        this.esSolicitante = this.isSolicitante;
        this.esConsultas = this.isConsultas;

        this.configurationService.getValue('Traces:EnabledOnDemand').subscribe(result => {
            if (this.esConsultas && this.esSolicitante) {
                this.showTracesWS = true;
            } else {
                this.showTracesWS = JSON.parse(result);
            }
        });

        this.configurationService.getValue('Aduanas:EnabledOnDemand').subscribe(result => {
            if (this.esConsultas && this.esSolicitante) {
                this.showAduanasWS = true;
            } else {
                this.showAduanasWS = JSON.parse(result);
            }
        });

        this.configurationService.getValue('InspectionWebServiceInterface:Mode').subscribe(result => {
            this.showSubmitWS = result == '1';
        });

        this.envioService.canSubmit(this.IdSolicitud).subscribe(result => {
            this.visibilitySubmitWS = result && this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.REENVIAR_TRACES_ADUANAS_WS).Visible;
        });

        this.createForm();

        //Ya no tiene sentido que se llame 'finalizar' pq no hace las inspecciones
        //if (this.esGrabador) {
        //    this.tituloBoton = "Finalizar";
        //    //this.addValidator("FechaCreacion", Validators.required);
        //    //this.addValidator("FechaRegistro", Validators.required);
        //}

        //Para saber si se actua como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitud', this.IdSolicitud.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());
        this.solicitudService.isSolicitudUsuario(params).subscribe(result => {
            this.laHeGrabadoYo = result;

            //VALIDACION INICIAL
            this.loadingEnvio = true;
            this.envioService.validarSolicitud(id).subscribe({
                next: result => {
                    this.loadingEnvio = false;
                    this.handlerValidarResponse(result, id);
                },
                error: error => {
                    this.loadingEnvio = false;
                    this.catchServerError(error);
                    this.mostrarBotones = false;
                },
            });
        });
    }

    private handlerValidarResponse(result: any, id: any): void {
        this.validacionCollection = result;
        this.loadingEnvio = true;
        if (id) {
            this.mostrarBotones = true;
            if (this.esInspector) {
                //Si es INSPECTOR
                this.solicitudService.getEnvioSolicitudInspector(id).subscribe({
                    next: result => {
                        this.loadingEnvio = false;
                        this.handlerEnvioSolicitudInspector(result);
                    },
                    error: error => {
                        this.loadingEnvio = false;
                        this.catchServerError(error);
                        this.mostrarBotones = false;
                    },
                });
            } else {
                //Si es SOLICITANTE o GRABADOR
                this.solicitudService.getEnvioSolicitud(id).subscribe({
                    next: result => {
                        this.loadingEnvio = false;
                        this.handlerEnvioSolicitud(result);
                    },
                    error: error => {
                        this.loadingEnvio = false;
                        this.catchServerError(error);
                        this.mostrarBotones = false;
                    },
                });
            }
        }
    }

    private handlerComunEnvioSolicitud(result: SolicitudViewModel): void {
        this.solicitud = result;
        this.codigoSolicitud = result.Codigo;
        this.codigoTraces =
            result.TwTraces != null && result.TwTraces.Codigo != null ? (result.TwTraces.Codigo.startsWith('CHED') ? result.TwTraces.Codigo : null) : null;
        this.identificadorNoProcede = this.codigoTraces == null && result.TwTraces != null && result.TwTraces.Codigo != null ? result.TwTraces.Codigo : null;
        this.fechaSolicitud = this.datepipe.transform(result.FechaEnvio, 'dd/MM/yyyy');
        this.IdTipoSolicitud = this.solicitud.IdTipoSolicitud;
        this.tituloTipoSolicitud = this.solicitud.TcTipoSolicitud.Descripcion;
        this.esClonada =
            result.TwSolicitudJerarquia != null && result.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION ? true : false;
        this.esRevisionSolicitante = this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE;
        this.esCanariasCf = this.solicitud.IdSubTipoSolicitud == (EnumIdsTcSubTipoSolicitud.ID_CANARIAS_CF || EnumIdsTcSubTipoSolicitud.ID_CANARIAS_PREDUA_CF);
        //SI ES EN PAPEL(o de grabador)
        if (this.solicitud.IdFormatoSolicitud == EnumIdsTcFormatoSolicitud.ID_PAPEL) {
            this.labelEmailOtlf = 'Teléfono';
            //Si esta firmado, tomo los valores de Razon Social Solicitante y Telefono
            if (this.solicitud.Firmado && this.solicitud.TSolicitanteAdministrativo != null) {
                this.SolicitanteOrazonSocial = this.solicitud.TSolicitanteAdministrativo.RazonSocialSolicitanteAdministrativo;
                this.EmailOtlf = this.solicitud.TSolicitanteAdministrativo.NumeroTelefonoSolicitanteAdministrativo;
            }
        }
        //SI ES POR LA APLICACION
        else {
            this.labelEmailOtlf = 'Correo Electrónico';
            //Si esta firmado, tomo los valores de Solicitante y Email
            if (this.solicitud.Firmado) {
                this.SolicitanteOrazonSocial = this.solicitud.TwUsuarioExterno.Apellidos + ', ' + this.solicitud.TwUsuarioExterno.Nombre;
                this.EmailOtlf = this.solicitud.TwUsuarioExterno.Email;
            }
        }
        //SI ES RE-IMPORTACION
        if (this.solicitud.EsReImportacion) {
            this.tituloTipoSolicitud += ' - Re-Importación';
        }
        //SI ES PREVIA
        if (this.solicitud.EsPrevia) {
            if (
                this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
            ) {
                this.tituloTipoSolicitud += ' - Previa';
            }
        }

        //SI ES CANARIAS con PIF CANARIO O HIGIENE
        //24062025. Esta validación cambia a servidor. Se deja comentado el código temporalmente
        //if (
        //    this.solicitud.IsCanariasPifCanarias ||
        //    //PCF peninsular (no canario) con higiene y sin chedpp (SV en península) todo junto (puro de Higiene en pcf península)
        //    !this.solicitud.IsPifCanarias || //&&
        //    //this.solicitud.TImportador?.ConfiguracionImportadorLugarDestinoSolicitud?.Higiene &&
        //    //!this.solicitud.TImportador?.ConfiguracionImportadorLugarDestinoSolicitud?.ChedPp) ||
        //    //PCF canario, no tipo canarias la solicitud (que entraría por la primera condición de este if)
        //    //con higiene y sin pcf canarias sv(SV en Canarias) todo junto(puro de Higiene en pcf canario)
        //    (this.solicitud.IsPifCanarias && this.IdTipoSolicitud != EnumIdsTcTipoSolicitud.ID_CANARIAS) //&&
        //    //this.solicitud.TImportador?.ConfiguracionImportadorLugarDestinoSolicitud?.Higiene &&
        //    //!this.solicitud.TImportador?.ConfiguracionImportadorLugarDestinoSolicitud?.PcfCanariasSv
        //) {
        this.envioService.getNumerosAutorizacion(this.IdSolicitud).subscribe({
            next: result => {
                if (result != null && result.length > 0) {
                    this.listNumAutorizacion = result;
                    this.showNRC = true; //@adua, para mostrar el listado de peticiones Aduanas con
                } else {
                    this.showNRC = false;
                }
            },
            error: error => {
                this.catchServerError(error);
            },
        });
        //} else {
        //    this.showNRC = false;
        //}
        this.visibilidadNoPrevia = !this.solicitud.EsPrevia || (this.solicitud.EsPrevia && this.solicitud.Codigo != null);

        this.tituloEstadoSolicitud = this.solicitud.TcEstadoSolicitud.Descripcion;
        this.esPredua = this.solicitud.TwTcSubTipoSolicitud != null && this.solicitud.TwTcSubTipoSolicitud.EsPreDua;
    }

    private handlerEnvioSolicitud(result: SolicitudViewModel): void {
        this.handlerComunEnvioSolicitud(result);

        //Si soy Grabador
        if (this.isGrabador && this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
            this.habilitarEnviar =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ENVIAR_SOLICITUD, this.solicitud.IdEstadoSolicitud).Visible &&
                (this.validacionCollection == null || this.validacionCollection.length == 0) &&
                this.laHeGrabadoYo;

            this.habilitarEdicion =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_ENVIO, this.solicitud.IdEstadoSolicitud).Editable &&
                (this.validacionCollection == null || this.validacionCollection.length == 0) &&
                this.laHeGrabadoYo;
        } else {
            this.habilitarEnviar =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ENVIAR_SOLICITUD, this.solicitud.IdEstadoSolicitud).Visible &&
                (this.validacionCollection == null || this.validacionCollection.length == 0);

            this.habilitarEdicion =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_ENVIO, this.solicitud.IdEstadoSolicitud).Editable &&
                (this.validacionCollection == null || this.validacionCollection.length == 0);
        }

        if (this.habilitarEdicion) {
            this.form.controls['Firmado'].enable();
        } else {
            this.form.controls['Firmado'].disable();
        }

        //Visibilidad de los errores de traces
        if (this.habilitarEnviar) {
            this.erroresEnvioTraces =
                this.solicitud.TwEnvioTracesCollection.length > 0 ? this.solicitud.TwEnvioTracesCollection[0].TwEnvioTracesErrorCollection : null;
            this.visibilityErroresTraces = this.erroresEnvioTraces == null ? false : true;

            //mensaje informativo
            if (this.visibilityErroresTraces) {
                this.addInfoMessage('Por favor, vuelva a intentar el envío cuando corrija la solicitud');
            }
        }

        this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio();
        //this.habilitarEnviar && !this.visibilityErroresTraces && !this.visibilityErroresAduanas && this.firmado;

        if (this.validacionCollection != null && this.validacionCollection.length > 0) {
            this.mensajeEmision = 'Se necesita completar:';
            this.visibilityCheckEnvioValue = false;
        } else if (this.erroresEnvioTraces && this.habilitarEnviar) {
            this.mensajeEmision = 'Existen errores de validación de TRACES:';
            this.visibilityCheckEnvioValue = false;
        } else {
            this.mensajesInformativosSegunEstados();
        }

        this.updateForm();
    }

    private handlerEnvioSolicitudInspector(result: SolicitudViewModel): void {
        this.handlerComunEnvioSolicitud(result);

        this.habilitarEnviar =
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ENVIAR_SOLICITUD, this.solicitud.IdEstadoSolicitud).Visible &&
            (this.validacionCollection == null || this.validacionCollection.length == 0) &&
            this.laHeGrabadoYo;

        this.habilitarEdicion =
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_ENVIO, this.solicitud.IdEstadoSolicitud).Editable &&
            (this.validacionCollection == null || this.validacionCollection.length == 0) &&
            this.laHeGrabadoYo;

        if (this.habilitarEdicion) {
            this.form.controls['Firmado'].enable();
        } else {
            this.form.controls['Firmado'].disable();
        }

        //botón Reenviar habilitado si el estado es Rechazado TRACES, así damos opción a corregir motivos, medidas, si es que es un rechazo
        this.deshabilitarSubmit = !(this.solicitud.IdEstadoSolicitud === EnumIdsTcEstadoSolicitud.ID_RECHAZADA_TRACES);

        this.visibilidadReenvioTraces = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.REENVIAR_TRACES, this.solicitud.IdEstadoSolicitud).Visible;

        if (this.visibilidadReenvioTraces) {
            //this.updateForm();
            this.erroresEnvioTraces = this.solicitud.TwEnvioTracesCollection[0].TwEnvioTracesErrorCollection;
        }
        this.updateForm();

        this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio();
        //this.habilitarEnviar && this.firmado && !this.visibilidadReenvioTraces && !this.visibilityErroresAduanas;

        this.mensajesInformativosSegunEstados();
    }

    private checkvisibilityCheckEnvio() {
        return this.habilitarEnviar && this.firmado && !this.visibilidadReenvioTraces && !this.visibilityErroresAduanas;
    }

    private mensajesInformativosSegunEstados() {
        let esRolSolicitante = (this.esGrabador && this.laHeGrabadoYo) || this.esSolicitante;

        //AQUÍ SE PUEDE DAR MÁS INFORMACIÓN AL SOLICITANTE SI, POR EJEMPLO, LAS PREVIAS.... ¿¿??
        switch (this.solicitud.IdEstadoSolicitud) {
            case EnumIdsTcEstadoSolicitud.ID_BORRADOR:
                //this.mensajeEmision = 'La solicitud está lista para ser enviada';
                //this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio(); //this.firmado; //check verde
                this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio();
                if (this.visibilityCheckEnvioValue || this.solicitud.EsPrevia) {
                    this.visibilityCheckEnvioValue = true;
                    this.mensajeEmision = 'La solicitud está lista para ser enviada';
                } else {
                    //si es por falta de Firma, informar con mensaje
                    this.mensajeEmision = !this.firmado ? 'Se necesita aceptar la Firma' : '';
                }
                break;

            case EnumIdsTcEstadoSolicitud.ID_NUEVA:
            case EnumIdsTcEstadoSolicitud.ID_EN_TRAMITE:
                if (esRolSolicitante) {
                    this.mensajeEmision = 'Solicitud enviada';
                    this.visibilityCheckEnvioValue = true; //check verde
                }
                if (this.esInspector) {
                    this.mensajeEmision = 'Se necesita completar: el apartado de inspecciones'; //detectar si solicitud aún no inspeccionada, para mostrar mensaje al inspector
                    this.visibilityCheckEnvioValue = false; //check atención
                    //this.inspeccionRealizada = false; //para que no continúe aunque se cumplan otras condiciones, ya que tener la inspección realizada es imprescindible
                }
                break;

            case EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE:
                if (esRolSolicitante) {
                    this.mensajeEmision = 'La solicitud tiene que ser revisada por el solicitante';
                    this.visibilityCheckEnvioValue = false; //check atención
                }
                if (this.esInspector) {
                    this.mensajeEmision = 'La solicitud ha sido devuelta al solicitante';
                    this.visibilityCheckEnvioValue = false; //check atención
                }
                break;

            case EnumIdsTcEstadoSolicitud.ID_RECHAZADA_INSPECTOR:
                if (this.codigoTraces != null) {
                    this.visibilityCheckEnvioValue = null; // true; //check verde
                    this.mensajeEmision = ''; //   "Solicitud enviada a TRACES";
                } else {
                    this.visibilityCheckEnvioValue = false; //check atención
                    this.mensajeEmision = 'Solicitud rechazada';
                }
                break;

            default:
                this.mensajeEmision = '';
                this.visibilityCheckEnvioValue = null; //check verde
                break;
            //this.mensajeEmision = 'La solicitud está lista para ser enviada';
            //this.visibilityCheckEnvioValue = true; //check verde
            //break;
        }
    }

    private guardRefreshPage(id: number) {
        //Fuerzo que lo haga siempre pq fallaba al refrescar cuando cambiaba de estado
        if (id) {
            // && !this.navMenuService.currentSolicitudImportacion.Id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    private createForm(): void {
        this.form = this.fb.group({
            IdEstadoDescripcion: null,
            Codigo: '',
            Fecha: null,
            Firmado: [{ value: false, disabled: true }],
            FechaEnvio: null,
            Solicitante: '',
            EmailOtlf: '',
            Certificado: '',
        });
    }

    private updateForm(): void {
        this.form.setValue({
            IdEstadoDescripcion: this.solicitud.TwTraces != null ? this.solicitud.TwTraces.IdEstadoDescripcion : null,
            Codigo: this.solicitud.TwTraces != null ? this.solicitud.TwTraces.Codigo : null,
            Fecha: this.solicitud.TwTraces != null ? this.datepipe.transform(this.solicitud.TwTraces.Fecha, 'dd/MM/yyyy') : null,
            Firmado: this.solicitud.Firmado,
            FechaEnvio: this.datepipe.transform(this.solicitud.FechaEnvio, 'dd/MM/yyyy HH:mm:ss'),
            Solicitante: this.SolicitanteOrazonSocial,
            EmailOtlf: this.EmailOtlf,
            Certificado: this.solicitud.Certificado,
        });
        this.firmado = this.solicitud.Firmado;
    }

    onSelectedFirmado() {
        if (this.form.controls['Firmado'].value) {
            this.firmado = true;
        } else {
            this.firmado = false;
        }
        this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio();

        if (this.visibilityCheckEnvioValue) {
            this.mensajeEmision = 'La solicitud está lista para ser enviada';
        } else {
            //si es por falta de Firma, informar con mensaje
            this.mensajeEmision = !this.firmado ? 'Se necesita aceptar la Firma' : '';
        }
    }

    enviarSolicitud() {
        this.confirmationService.confirm({
            message: '¿Está seguro de enviar la solicitud?',
            accept: () => {
                this.mensajeEmision = '';
                this.visibilityCheckEnvioValue = null;

                this.onSubmit();
            },
        });
    }

    sendV3OnDemand() {
        this.visibilitySpinnerV3 = true;
        this.envioService.sendV3OnDemand(this.IdSolicitud).subscribe({
            next: () => {
                this.notificacionService.addSuccessMessage('Solicitud Enviada (V3) correctamente');
                this.visibilitySpinnerV3 = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerV3 = false;
            },
        });
    }

    sendTracesOnDemand() {
        this.visibilitySpinnerTNT = true;
        this.envioService.sendTracesOnDemand(this.IdSolicitud).subscribe({
            next: res => {
                if (res.IsOK) {
                    this.notificacionService.addSuccessMessage('Solicitud Aceptada en TRACES TNT con:' + res.CHEDPPCode);
                } else {
                    this.notificacionService.addErrorMessage('Solicitud Rechazada en TRACES TNT');
                }
                this.visibilitySpinnerTNT = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerTNT = false;
            },
        });
    }

    submitOnDemand() {
        this.deshabilitarSubmit = true;
        this.notifyAsyncRequest();

        this.envioService.submit(this.IdSolicitud).subscribe({
            next: res => {
                if (res.Status == 1) {
                    this.notificacionService.addSuccessMessage(res.Description);
                } else if (res.Status == 2) {
                    this.notificacionService.addErrorMessage(res.Description);
                }
                this.deshabilitarSubmit = false;
                this.notifyAsyncResponse();
                this.ngOnInit();
            },
            error: error => {
                this.catchServerError(error);
                this.deshabilitarSubmit = false;
                this.notifyAsyncResponse();
            },
        });
    }

    private notifyAsyncRequest() {
        let async = new AsyncInfoRequestViewModel();
        async.Caption = this.solicitud.Codigo;
        async.Id = this.IdSolicitud;
        async.Description = 'Enviando TRACES/Aduanas';
        this.asyncInfoService.notifyRequest(async);
    }
    private notifyAsyncResponse() {
        let async = new AsyncInfoResponseViewModel();

        async.Id = this.IdSolicitud;
        this.asyncInfoService.notifyResponse(async);
    }

    resetTracesOnDemand() {
        this.visibilitySpinnerTNTReset = true;
        this.envioService.resetTracesOnDemand(this.IdSolicitud).subscribe({
            next: () => {
                this.notificacionService.addSuccessMessage('Solicitud preparada para Enviar a TRACES NT de nuevo');
                this.ngOnInit();
                this.visibilitySpinnerTNTReset = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerTNTReset = false;
            },
        });
    }

    resetV3OnDemand() {
        this.visibilitySpinnerV3Reset = true;
        this.envioService.resetV3OnDemand(this.IdSolicitud).subscribe({
            next: () => {
                this.notificacionService.addSuccessMessage('Solicitud preparada para Enviar a V3 de nuevo');
                this.visibilitySpinnerV3Reset = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerV3Reset = false;
            },
        });
    }

    reenviarTraces() {
        this.confirmationService.confirm({
            message: '¿Está seguro de reenviar la solicitud a TRACES?',
            accept: () => {
                this.resetTracesOnDemand();
            },
        });
    }

    ignorarTraces() {
        this.confirmationService.confirm({
            message: '¿Está seguro de ignorar el envío a TRACES para esta solicitud?',
            accept: () => {
                this.visibilitySpinner = true;
                this.envioService.ignoreTracesOnDemand(this.IdSolicitud).subscribe({
                    next: () => {
                        this.notificacionService.addSuccessMessage('Solicitud preparada para Ignorar el envío a TRACES NT');
                        this.ngOnInit();
                        this.visibilitySpinner = false;
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            },
        });
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.IdSolicitud]);
    }

    private manageValidateAduanasV3(responseAduanas: ValidationInfoResponseViewModel) {
        if (responseAduanas.IsOk) {
            this.solicitud.Firmado = this.firmado;
            this.envioService.envioSolicitud(this.solicitud).subscribe({
                next: () => {
                    this.addSuccessMessage('Solicitud enviada correctamente');
                    this.ngOnInit();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.mostrarBotones = false;
                    this.isCollapsedReenvioTraces = false;
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.visibilityErroresAduanas = true;
            this.addErrorMessage('Error en la validación de Aduanas V3');
            this.visibilitySpinner = false;
            this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio(); //this.habilitarEnviar && !this.visibilityErroresTraces && !this.visibilityErroresAduanas && this.firmado;

            this.errorEnvioAduanas = responseAduanas?.ErrorList[0];
        }
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        //VUELVO A VALIDAR
        this.envioService.validarSolicitud(this.solicitud.Id).subscribe({
            next: result1 => {
                this.validacionCollection = result1;

                //Si no es PREVIA, o si es una PREVIA que ya dejó de serlo (y tiene código de solicitud)
                if (!this.solicitud.EsPrevia || (this.solicitud.EsPrevia && this.solicitud.Codigo != null)) {
                    //Si no hay errores llamo a ValidateOnDemand
                    if (this.validacionCollection.length == 0) {
                        this.envioService.validateOnDemand(this.solicitud.Id).subscribe({
                            next: result2 => {
                                this.handlerValidateOnDemand(result2);
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.mostrarBotones = false;
                                this.visibilitySpinner = false;
                            },
                        });
                    }
                } else {
                    //SI ES PREVIA NO SE HACEN LAS VALIDACIONES DE TRACES Y ADUANAS
                    //Si no hay errores ENVIO

                    this.envioService.envioSolicitud(this.solicitud).subscribe({
                        next: () => {
                            this.addSuccessMessage('Solicitud enviada correctamente');
                            this.ngOnInit();
                            this.visibilitySpinner = false;
                        },
                        error: error => {
                            this.catchServerError(error);
                            this.mostrarBotones = false;
                            this.isCollapsedReenvioTraces = false;
                            this.visibilitySpinner = false;
                        },
                    });
                }
            },
            error: error => {
                this.catchServerError(error);
                this.isCollapsedReenvioTraces = false;
                this.visibilitySpinner = false;
            },
        });
    }

    private handlerValidateOnDemand(result2: ValidationInfoResponseViewModel[]): void {
        let respuestaTraces = result2?.find(s => s.RequestService == RequestService.TRACES);
        let respuestaAduanas = result2?.find(s => s.RequestService == RequestService.ADUANAS);

        if (respuestaTraces) {
            if (respuestaTraces.IsOk) {
                if (respuestaAduanas) {
                    //Si no hay errores llamo a manageValidateAduanasV3 si hay respuesta
                    this.manageValidateAduanasV3(respuestaAduanas);
                } else {
                    this.solicitud.Firmado = this.firmado;
                    this.envioService.envioSolicitud(this.solicitud).subscribe({
                        next: () => {
                            this.addSuccessMessage('Solicitud enviada correctamente');
                            this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio();
                            //this.habilitarEnviar && !this.visibilityErroresTraces && !this.visibilityErroresAduanas && this.firmado;
                            this.ngOnInit();
                            this.visibilitySpinner = false;
                        },
                        error: error => {
                            this.catchServerError(error);
                            this.mostrarBotones = false;
                            this.isCollapsedReenvioTraces = false;
                            this.visibilitySpinner = false;
                        },
                    });
                }
            } else {
                this.visibilityErroresTraces = true;
                this.erroresEnvioTraces = respuestaTraces.ErrorList;
                this.addErrorMessage('Error en la validación de TRACES');
                this.visibilitySpinner = false;
                //this.visibilityCheckEnvioValue = this.checkvisibilityCheckEnvio();
                //this.habilitarEnviar && !this.visibilityErroresTraces && !this.visibilityErroresAduanas && this.firmado;
            }
        } else if (respuestaAduanas) {
            this.manageValidateAduanasV3(respuestaAduanas);
        }
    }

    get disableBack(): boolean {
        return (
            this.visibilitySpinnerTNTReset || this.visibilitySpinner || this.visibilitySpinnerTNT || this.visibilitySpinnerV3 || this.visibilitySpinnerV3Reset
        );
    }
}
